import { useNavigate } from 'react-router-dom'
import { Tile, Layer, Tag } from '@carbon/react'
import {
  Idea,
  ArrowUp,
  ArrowDown,
  ArrowsHorizontal,
} from '@carbon/icons-react'
import styles from './PersonalInsights.module.scss'

export interface Insight {
  type: string
  title: string
  description: string
  trend?: 'positive' | 'negative' | 'neutral'
  value?: unknown
  activityId?: string
}

export interface PersonalInsightsProps {
  insights: Insight[]
}

function TrendIcon({ trend }: { trend?: 'positive' | 'negative' | 'neutral' }) {
  if (trend === 'positive')
    return <ArrowUp size={16} className={styles.iconPositive} />
  if (trend === 'negative')
    return <ArrowDown size={16} className={styles.iconNegative} />
  return <ArrowsHorizontal size={16} className={styles.iconNeutral} />
}

function trendClass(trend?: string) {
  if (trend === 'positive') return styles.itemPositive
  if (trend === 'negative') return styles.itemNegative
  return styles.itemNeutral
}

export function PersonalInsights({ insights }: PersonalInsightsProps) {
  const navigate = useNavigate()

  if (!insights || insights.length === 0) {
    return null
  }

  return (
    <Layer className={styles.wrapper}>
      <Tile className={styles.tile}>
        <div className={styles.header}>
          <Idea size={20} className={styles.headerIcon} />
          <h3 className={styles.title}>Insights Clés</h3>
        </div>
        <ul className={styles.list}>
          {insights.map((insight, index) => (
            <li
              key={index}
              className={`${styles.item} ${trendClass(insight.trend)} ${insight.activityId ? styles.itemClickable : ''}`}
              role={insight.activityId ? 'button' : undefined}
              tabIndex={insight.activityId ? 0 : undefined}
              onClick={() =>
                insight.activityId &&
                navigate(`/learning/activities/${insight.activityId}`)
              }
              onKeyDown={e =>
                insight.activityId &&
                (e.key === 'Enter' || e.key === ' ') &&
                navigate(`/learning/activities/${insight.activityId}`)
              }
            >
              <div className={styles.iconWrapper}>
                <TrendIcon trend={insight.trend} />
              </div>
              <div className={styles.content}>
                <h4 className={styles.insightTitle}>{insight.title}</h4>
                <p className={styles.insightDescription}>
                  {insight.description}
                </p>
                <Tag type="outline" size="sm" className={styles.tag}>
                  {insight.type}
                </Tag>
              </div>
            </li>
          ))}
        </ul>
      </Tile>
    </Layer>
  )
}
